import {DomainEvent} from './DomainEvent';
import {StreamEntry} from '../resources/StreamEntry';

export class StreamEntryUpdated extends DomainEvent<StreamEntry> {

}
